import classNames from 'classnames';

import {colors} from 'shells/colors/colors';
import {ChatRegularIcon, TextRegularAiIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './sidebar-thread-list-item.module.css';

interface Props {
    entityName: string;
    messageCount: number;
    displayMessage: string;
    summary?: string | null;
    selected: boolean;
    onSelect: () => void;
}

export function SidebarThreadListItem(props: Props) {
    const hasSummary = Boolean(props.summary);
    const messageContent = props.summary || props.displayMessage;

    return (
        <div
            className={classNames(
                styles['sidebar-thread-list-item'],
                props.selected && styles.selected
            )}
            onClick={props.onSelect}
        >
            <Stack justifyContent='space-between' isFullHeight={true}>
                <Body size='small' truncate={{type: 'block', maxLines: 3}}>
                    {hasSummary && (
                        <span className={styles['summary-icon']}>
                            <TextRegularAiIcon
                                // @ts-expect-error
                                color={colors.aiPurplePrimary}
                                size={20}
                                wrapWithDiv={false}
                            />
                        </span>
                    )}
                    {messageContent}
                </Body>
                <Stack isHorizontal={true} justifyContent='space-between'>
                    <Body size='small' truncate={{type: 'block', maxLines: 1}}>
                        {props.entityName}
                    </Body>
                    <Stack isHorizontal={true} spacing={4}>
                        {/* @ts-expect-error */}
                        <ChatRegularIcon size={16} wrapWithDiv={false} color={colors.greyLt} />
                        <Body size='small' color='light'>
                            {props.messageCount}
                        </Body>
                    </Stack>
                </Stack>
            </Stack>
        </div>
    );
}
